import ApplyPasswordReset from '../mutations/ApplyPasswordReset.gql'

export default function (variables) {
  return {
    mutation: ApplyPasswordReset,
    variables: variables,
  }
}
